import api from "./configuration";
import apiUrl from "./url";
import store from "@/store";
const request = async (method, path, data, params) => {
	const token = store.getState().token;
	if (!token) throw Error("Sessione non più attiva.");
	return (
		await api.request({
			method,
			url: apiUrl + "/Clubs" + path,
			data,
			params,
			useAuthInterceptor: false,
			headers: {Authorization: `Bearer ${token}`},
		})
	).data;
};
export const ClubScoutingAPI = {
	read: (id) => request("GET", `/${id}/scouting-profile`),
	save: (id, data) => request("PUT", `/${id}/scouting-profile`, data),
	addAlias: (id, alias, version) =>
		request("POST", `/${id}/aliases`, {alias, version}),
	removeAlias: (id, alias, version) =>
		request(
			"DELETE",
			`/${id}/aliases/${encodeURIComponent(alias)}`,
			undefined,
			{version},
		),
};
